/**
 * Dev-server error overlays treat browser-extension failures as app crashes.
 * BornFree's marketing PWA does not connect wallets — suppress MetaMask/extension
 * noise so local review is not blocked.
 */

export function isBrowserExtensionRuntimeNoise(reason: unknown): boolean {
  if (reason == null) return false;

  const message =
    typeof reason === "string"
      ? reason
      : typeof reason === "object" &&
          reason !== null &&
          "message" in reason &&
          typeof (reason as { message: unknown }).message === "string"
        ? (reason as { message: string }).message
        : String(reason);

  const stack =
    typeof reason === "object" &&
    reason !== null &&
    "stack" in reason &&
    typeof (reason as { stack: unknown }).stack === "string"
      ? (reason as { stack: string }).stack
      : "";

  const haystack = `${message}\n${stack}`;

  if (/Failed to connect to MetaMask/i.test(haystack)) return true;
  if (/chrome-extension:\/\/nkbihfbeogaeaoehlefnkodbefgpgknn/i.test(haystack)) {
    return true;
  }
  if (
    /chrome-extension:\/\//i.test(haystack) &&
    /MetaMask/i.test(haystack)
  ) {
    return true;
  }

  return false;
}

/**
 * Capture-phase listeners stop CRA/WDS from seeing extension noise.
 * Pair with scripts/start.js runtimeErrors filter (authoritative for overlay).
 */
export function installExtensionRuntimeNoiseFilter(): void {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (isBrowserExtensionRuntimeNoise(event.reason)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener(
    "error",
    (event) => {
      if (isBrowserExtensionRuntimeNoise(event.error ?? event.message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}
